<template>
  <div class="monitor">
    <a-button-box :active="state.matches('mobileUtilityMenu.visible')">
      <a-button ref="toggle" variant="link-primary" @click="toggleHandler">
        <a-icon name="more-h" />
      </a-button>
    </a-button-box>
    <Transition name="fade">
      <div class="box mb--0 mt--1" v-show="state.matches('mobileUtilityMenu.visible')" ref="target">
        <div class="d--flex justify-content--center">
          <meeting-zoom
            :controls="user.isAssistant"
            :disabled="session.notClientCamera && app.state.matches('app.view.meeting.call')"
            class="pte--auto"
          />
          <a-button-box :active="state.matches('mobileUtilityMenu.visible')">
            <a-button variant="link-primary" @click="openModalParticipants">
              <a-icon name="people" />
              <a-badge :value="session.users.length" class="ms--1" />
            </a-button>
          </a-button-box>
          <a-button-box :active="state.matches('mobileUtilityMenu.visible')">
            <a-button variant="link-primary" @click="openModalConnectionStatus">
              <a-icon
                v-if="!user.isInLobby"
                :name="user.networkIcon(user.qualityNetwork).name"
                :color="user.networkIcon(user.qualityNetwork).color"
                :width="24"
                :height="24"
              />
              <a-icon v-else :name="`wifi-on`" :color="`grey`" :width="24" :height="24" />
            </a-button>
          </a-button-box>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import {useAppStore, useSessionStore, useUserStore} from '@/stores'
import {useMeetingMachine} from '@/state'
import {onClickOutside} from '@vueuse/core'
import AIcon from '@/components/AIcon.vue'
const app = useAppStore()
const session = useSessionStore()
const user = useUserStore()
const {state, send} = useMeetingMachine()
const toggle = ref(null)
const target = ref(null)

function openModalParticipants() {
  app.transition('SHOW_PARTICIPANTS_MODAL')
}

function openModalConnectionStatus() {
  app.transition('SHOW_CONNECTION_STATUS_MODAL')
}

function toggleHandler() {
  if (state.value.matches('mobileUtilityMenu.visible')) {
    send('HIDE_MEETING_MOBILE_UTILITY_MENU')
  } else {
    send('SHOW_MEETING_MOBILE_UTILITY_MENU')
  }
}

onClickOutside(target, event => {
  if (state.value.matches('mobileUtilityMenu.visible') && event.target !== toggle.value.$el) {
    send('HIDE_MEETING_MOBILE_UTILITY_MENU')
  }
})
</script>

<style lang="scss">
$participants-opacity: 0.4;
$participants-avatar-size: 2rem;
$participants-avatar-bg: $purple-200;
$participants-avatar-color: $primary;
$participants-max-width: calc(100vw - #{$box-spacer * 2});
$participants-name-max-width: 10rem;

.monitor {
  position: relative;
  .box {
    position: absolute;
    top: 100%;
    right: 0;
    max-width: $participants-max-width;
    max-height: calc(
      100dvh - #{$component-height + $box-spacer + map-get($spacers, 2)} - 3.625rem
    ); // TODO: tools height variable
    overflow: auto;
  }
}
</style>
